"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = _interopRequireDefault(require("../styles"));
var _AccordionSummary = _interopRequireDefault(require("@mui/material/AccordionSummary"));
var _ChevronDown = _interopRequireDefault(require("@ellucian/ds-icons/lib/ChevronDown"));
var _ExpansionPanelContext = _interopRequireDefault(require("./internal/ExpansionPanelContext"));
var _globalSpacing = require("./../globalSpacing");
var _tokens = require("../styles/tokens");
var _excluded = ["classes", "leftIconDisplay", "expandIconProps"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = function styles(theme) {
  var _standard;
  return {
    root: {
      padding: 0,
      color: _tokens.colorTextPrimary,
      outline: 'none',
      minHeight: 'auto',
      '&$focused': {
        backgroundColor: 'transparent'
      },
      '&$disabled': {
        opacity: 1
      },
      '&$expanded': {
        minHeight: 'auto',
        margin: 0,
        '& $content': {
          margin: 0
        }
      }
    },
    expanded: {},
    disabled: {
      backgroundColor: _tokens.colorBrandNeutral100,
      '& > $content > *': {
        color: _tokens.colorBrandNeutral400
      }
    },
    focused: {
      boxShadow: _tokens.boxShadowFocusInset,
      outline: 'none'
    },
    iconButtonRoot: {
      fontSize: _tokens.fontSizeLarge
    },
    content: {
      margin: 0
    },
    leftIconDisplay: {
      flexDirection: 'row-reverse'
    },
    expandIcon: {},
    standard: (_standard = {
      padding: _tokens.spacing20 + " " + _tokens.spacing40
    }, _standard[theme.breakpoints.up('lg')] = {
      padding: _tokens.spacingInsetShort30
    }, _standard),
    none: {
      padding: 0
    },
    gutters: {},
    contentGutters: {},
    // in mui v4, the wrapper for expandIcon has a default padding of 12px
    // we don't have a token for the rem equivalent
    expandIconWrapper: {
      marginRight: '-.75rem',
      padding: '.75rem'
    },
    leftExpandIconWrapper: {
      marginLeft: '-.75rem',
      padding: '.75rem'
    }
  };
};

/**
 * The Summary component of ExpansionPanel. Content is displayed before the ExpansionPanel is expanded.
 */
var ExpansionPanelSummary = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _classNames, _classNames2, _classNames3;
  var classes = props.classes,
    leftIconDisplay = props.leftIconDisplay,
    expandIconProps = props.expandIconProps,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var _useContext = (0, _react.useContext)(_ExpansionPanelContext.default),
    disabled = _useContext.disabled,
    spacingOptions = _useContext.spacingOptions;
  var classOverrides = {
    root: (0, _classnames.default)(classes.root, (_classNames = {}, _classNames[classes.leftIconDisplay] = leftIconDisplay, _classNames), (_classNames2 = {}, _classNames2[classes.standard] = spacingOptions.spacing === _globalSpacing.spacingVariant.STANDARD, _classNames2), (_classNames3 = {}, _classNames3[classes.none] = spacingOptions.spacing === _globalSpacing.spacingVariant.NONE, _classNames3)),
    disabled: classes.disabled,
    focusVisible: classes.focused,
    content: classes.content,
    expanded: classes.expanded,
    expandIconWrapper: classes.expandIconWrapper
  };
  if (leftIconDisplay) {
    classOverrides.expandIconWrapper = (0, _classnames.default)(classes.leftExpandIconWrapper, 'eds-expansion-panel-icon-left-position');
  }
  return /*#__PURE__*/_react.default.createElement(_AccordionSummary.default, (0, _extends2.default)({
    expandIcon: /*#__PURE__*/_react.default.createElement(_ChevronDown.default, (0, _extends2.default)({
      className: classes.iconButtonRoot,
      fill: disabled ? _tokens.colorBrandNeutral400 : _tokens.colorBrandNeutral500
    }, expandIconProps)),
    classes: classOverrides,
    ref: ref
  }, rest));
});
ExpansionPanelSummary.muiName = 'AccordionSummary';
ExpansionPanelSummary.displayName = 'ExpansionPanelSummary';
ExpansionPanelSummary.propTypes = {
  /**
   * The content of the expansion panel summary.
   */
  children: _propTypes.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * Properties applied to the icon element.
   */
  expandIconProps: _propTypes.default.object,
  /**
   * Displays the expandIcon on the left side of the ExpansionPanel.
   */
  leftIconDisplay: _propTypes.default.bool,
  /**
   * @ignore
   */
  onChange: _propTypes.default.func,
  /**
   * @ignore
   */
  onClick: _propTypes.default.func
};
ExpansionPanelSummary.defaultProps = {
  leftIconDisplay: false
};
var _default = (0, _styles.default)(styles)(ExpansionPanelSummary);
exports.default = _default;